import { useGtag } from "vue-gtag-next";

export function logEventLoginMethod(loginMethod: string) {
	const { event } = useGtag();
	try {
		if (loginMethod === 'login') {
			event('login', {
				event_label: 'login',
			});
		} else if (loginMethod === 'sign_up') {
			event('sign_up', {
				event_label: 'sign_up',
			});
		} else {
			console.warn('Unknown login method:', loginMethod);
		}
	} catch (error) {
		console.error(`Failed to send event for ${loginMethod}:`, error);
	}
}


export function logOfferStartEvent(offer: any, userId: number) {
	const { event } = useGtag();
	try {
		event('offerStart', {
			url: window.location.href,
			path: location.pathname,
			name: offer.name,
			user_id: userId,
			offer_id: offer.id,
			network_id: offer.network_id,
			category_id: offer.category_id,
			rating: offer.rating_info,
			coins_amount: offer.coins_amount,
			platforms: offer.platforms,
		});
	} catch (error) {
		console.error('Failed to send offerStart event:', error);
	}
}
